export default __webpack_public_path__ + "static/media/t1.min.b32e507a.png";